// Repeating UTC-aligned cycles, independent of page loads and tab throttling.
if (!customElements.get('mm-countdown')) {
  customElements.define('mm-countdown', class extends HTMLElement {
    connectedCallback() {
      this.period = Math.max(1, Number(this.dataset.minutes) || 60) * 60000;
      this.hours = this.querySelector('[data-hours]');
      this.minutes = this.querySelector('[data-minutes]');
      this.seconds = this.querySelector('[data-seconds]');
      this.clock = this.querySelector('[role="timer"]');
      this.update = () => {
        const remaining = Math.ceil((this.period - (Date.now() % this.period)) / 1000);
        const h = Math.floor(remaining / 3600);
        const m = Math.floor((remaining % 3600) / 60);
        const s = remaining % 60;
        this.hours.textContent = String(h).padStart(2, '0');
        this.minutes.textContent = String(m).padStart(2, '0');
        this.seconds.textContent = String(s).padStart(2, '0');
        this.clock.setAttribute('aria-label', `${h} hours, ${m} minutes, ${s} seconds remaining`);
      };
      this.measure = () => {
        document.documentElement.style.setProperty('--mm-countdown-height', `${this.getBoundingClientRect().height}px`);
        const header = document.querySelector('.section-header.menu-open');
        if (header) document.documentElement.style.setProperty('--header-bottom-position', `${header.getBoundingClientRect().bottom}px`);
      };
      this.update();
      this.measure();
      this.interval = setInterval(this.update, 1000);
      this.observer = new ResizeObserver(this.measure);
      this.observer.observe(this);
      document.addEventListener('visibilitychange', this.update);
    }
    disconnectedCallback() {
      clearInterval(this.interval);
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.update);
      document.documentElement.style.removeProperty('--mm-countdown-height');
    }
  });
}
